export class PromiseAborted extends Error {}

export class TimeoutController extends AbortController {
    private _timer: ReturnType<typeof setTimeout> = setTimeout(() => {
        /* */
    })
    private _ms: number
    private _timedOut = false

    constructor(ms: number) {
        super()

        this._ms = ms
        this._timer = setTimeout(() => {
            this._timedOut = true
            this.abort()
        }, ms)
    }

    get timedOut() {
        return this._timedOut
    }

    abort() {
        clearTimeout(this._timer)
        return super.abort()
    }

    clear() {
        clearTimeout(this._timer)
    }

    abortAfter(timeout: number) {
        this._ms = timeout

        clearTimeout(this._timer)

        this._timer = setTimeout(() => {
            this._timedOut = true
            this.abort()
        }, this._ms)
    }

    reset() {
        clearTimeout(this._timer)
        this._timer = setTimeout(() => {
            this._timedOut = true
        }, this._ms)
    }
}
